import { render } from "./MiHorario.vue?vue&type=template&id=664e7dd0"
import script from "./MiHorario.vue?vue&type=script&lang=js"
export * from "./MiHorario.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__